<template>
  <!-- 一般商品詳情頁 -->
  <div class="scroll_flex_container product_detail_container" style="background-color: white;">
    <div class="column_center_start product_info">
      <div class="row_center_start product_img">
        <img v-if="productImage" :src="productImage" class="h-[180px] w-[180px] rounded-md shrink-0" />


        <div class="column_center_start flex-grow text-left px-2">
          <text class="text-black text-2xl font-semibold text_three_lines text-left w-full">{{ product.name }}</text>
          <text class="text-[#FD5001] w-full">${{ totalPrice }}</text>
        </div>
        <div class="row_start_start" style="height: 100%;">
          <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
            @click="closeProductDetail">
            <text id="close" class="button-icon"
              style="color: #000; font-size: 32px; height: 32px; width: 32px">close</text>
          </div>
        </div>
      </div>

      <div class="column_center_start" style="width: 100%; flex-grow: 1; padding-bottom: 30px;">
        <text class="description">
          {{ product.description }}
        </text>
        <div class="column_center_center" style="width: 100%;" v-if="productSpecSettings.length">
          <div class="column_center_center" style="width: 92%;" v-for="(spec, specIndex) in productSpecSettings"
            :key="specIndex">
            <div class="row_center_start" style="width: 100%; padding: 15px 0">
              <text class="title">{{ spec.name }}</text>
              <text class="subTitle" v-if="spec.mustHave">必選</text>
              <text class="subTitle" v-if="!spec.isSingleSelection">複選[最少{{
                spec.multiSelectionMin }}, 最多{{ spec.multiSelectionMax }}]{{
                  spec.allowSelectManyTimes ? '(可重複選)' : '' }}</text>
            </div>
            <div class="column_center_center w-full" v-if="!spec.allowSelectManyTimes">
              <!-- 單選 / 複選欄位 -->
              <productDetailSingleSubOption class="column_start_start option"
                :class="{ active: isSelected(specIndex, subSpecIndex) }"
                v-for="(subSpec, subSpecIndex) in spec.specOptions" :key="subSpecIndex" :product="subSpec"
                @click="spec.multiSelectionMax === 1 || spec.isSingleSelection ? selectedSingleItem(specIndex, subSpecIndex) : selectedMultipleItems(specIndex, subSpecIndex)" />

            </div>

            <div class="column_center_start w-full" v-if="spec.allowSelectManyTimes">
              <!-- 可重複選欄位 -->
              <productDetailMultiSubOption class="column_center_start option"
                :class="{ active: isSelected(specIndex, subSpecIndex) }"
                v-for="(subSpec, subSpecIndex) in spec.specOptions" :key="subSpecIndex" :product="subSpec"
                @addQuantity="addOptionQuantity(specIndex, subSpecIndex)"
                @subtractQuantity="subtractOptionQuantity(specIndex, subSpecIndex)"
                :quantity="checkOptionQuantity(specIndex, subSpecIndex)" />
            </div>
          </div>
        </div>
      </div>
      <div class="column_start_start w-full mt-5 mb-4 px-[3%]">
        <text class="title">備註</text>
        <div class="w-full order_note" :class="noteTextAreaFocus ? 'border-[#FD5001]' : 'border-[#DDDDDD]'"
          @click="noteTextAreaFocus != noteTextAreaFocus">
          <textarea class="" :maxlength="productNoteMaxLength" :placeholder="productNotePlaceHolder" v-model="note"
            v-on:focus="noteTextAreaFocus = true" v-on:blur="noteTextAreaFocus = false"></textarea>
          <div class="w-full row_center_end">
            <p class="text-sm text-[#666666] h-5">{{ note.length }}/{{ productNoteMaxLength }}</p>
          </div>
        </div>
      </div>
    </div>
    <AddToCart :quantity="quantity" @addToCart="addToCart" @updateQuantity="updateQuantity"></AddToCart>
  </div>
</template>
<script>
import addToCart from "@/components/store/addToCart.vue";
import commonUtilities from "@/utils/common.utils";
import productDetailSingleSubOption from "@/components/store/productDetailSingleSubOption.vue";
import productDetailMultiSubOption from "@/components/store/productDetailMultiSubOption.vue";
import { mapGetters } from 'vuex'
export default {
  components: {
    AddToCart: addToCart,
    productDetailSingleSubOption,
    productDetailMultiSubOption

  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
      // 使用者輸入的數量, 如果輸入數量為0, 則顯示 props quantity
      quantity: 1,
      showMarkUpOptions: [],
      selectedOption: [],
      showCustomizePopup: false,
      productSpecSettings: [],
      note: "",
      noteTextAreaFocus: false
    };
  },
  computed: {
    productNoteMaxLength() {
      return this.$store.state.order.productNoteMaxLength
    },
    productNotePlaceHolder() {
      return this.$store.state.order.productNotePlaceHolder
    },
    productImage() {
      return this.$store.getters['product/getProductImageById'](this.product.id)
    },
    totalPrice() {
      const customizedTotalPrice = this.productSpecSettings.reduce((total, spec) => {
        return total += spec.subSpecOptionSelectCount.reduce((total, count, index) => {
          if (count === 0 || !spec.specOptions || !spec.specOptions.length) return total;
          return total += count * spec.specOptions[index].price
        }, 0)
      }, 0)


      return (this.productPrice + customizedTotalPrice) * this.quantity;
    },
    ...mapGetters('spreadsheet', {
      comboSubItems: 'comboSubItems',
      specifications: 'specifications',
      products: 'products',
      productComboSpec: 'productComboSpec'
    }),
    productPrice() {
      return Number(this.product?.price)
    }
  },
  mounted() {
    console.log('product detail', this.product);
    this.productSpecSettingsInit()
  },
  methods: {
    productSpecSettingsInit() {
      this.productSpecSettings = this.product.productSpecSettings.map(subSpec => {
        const specIndex = this.specifications.findIndex(spec => spec.id === subSpec.subSpecID)
        let spec = {}
        if (specIndex !== -1) {
          spec = this.specifications[specIndex]
          // spec.specOptions 有多少選項 就在 subSpecOptionSelectCount 設定多少個 0
          subSpec['subSpecOptionSelectCount'] = spec?.specOptions.map(() => 0) || []
        }
        // 如果全單規格啟用，需將全單規格加入 order/orderSpecs
        if (spec.enableForProductComboSpec === true) {
          let productComboSpec = this.productComboSpec.find(el => el.id === subSpec.subSpecID)
          productComboSpec['subSpecOptionSelectCount'] = spec?.specOptions.map(() => 0) || []
          this.$store.dispatch('order/addOrderSpecs', { ...subSpec, productSpec: { ...spec } })
        }
        return { ...subSpec, ...spec }
        // 全單規格不需要顯示在 productSpecSettings
      }).filter(s => !s.enableForProductComboSpec)
      console.log('productSpecSettings', this.productSpecSettings)
    },
    checkOptionQuantity(specIndex, subSpecIndex) {
      return this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]
    },
    addOptionQuantity(specIndex, subSpecIndex) {
      // 複選 ＆ 可重複選則加點數量
      // 檢查是否超過最大選擇數
      const currentSpecSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
      const currentSpecSelectionMax = this.productSpecSettings[specIndex].multiSelectionMax
      if (currentSpecSelectCount >= currentSpecSelectionMax) {
        commonUtilities.createToast("warning", `最多選擇${currentSpecSelectionMax}個`, "")
        return
      }
      this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]++
    },
    subtractOptionQuantity(specIndex, subSpecIndex) {
      const currentSpecSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
      // 如果加點數量為 0 或是該選項沒有被選中，則不做任何事
      if (currentSpecSelectCount === 0 || this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] === 0) {
        return
      }
      // 如果加點數量為1，則移除選項
      if (currentSpecSelectCount == 1) {
        this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
        return
      }
      // 如果加點數量大於1，則數量減一，並移除其中一個選項
      if (currentSpecSelectCount > 1) {
        this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
      }
    },
    toBoolean(value) {
      return (/true/).test(value)
    },
    selectedSingleItem(specIndex, subSpecIndex) {
      // 單選
      const hasSelected = this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0

      if (!hasSelected) {
        // 將選到的 subSpecOptionSelectCount[subSpecIndex] 設為 1，其餘設為0
        this.productSpecSettings[specIndex].subSpecOptionSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.map((el, i) => {
          return i === subSpecIndex ? 1 : 0
        })
      } else {
        this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] = 0
      }
    },
    selectedMultipleItems(specIndex, subSpecIndex) {
      // 複選
      // 檢查選項是否已經被選中
      const hasSelected = this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0
      const totalCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)

      if (!hasSelected) {
        // 檢查是否超過最大選擇數
        if (totalCount >= this.productSpecSettings[specIndex].multiSelectionMax) {
          commonUtilities.createToast("warning", `最多選擇${this.productSpecSettings[specIndex].multiSelectionMax}個`, "")
          return
        }
        // 如果沒有被選中，則添加到選中的選項中
        this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]++
      } else {
        // 如果已經被選中，則從選中的選項中移除
        this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
      }
    },
    isSelected(specIndex, subSpecIndex) {
      return this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0
    },
    closeProductDetail() {
      this.$emit("close");
    },
    updateQuantity(value) {
      this.quantity = value
    },
    cartValidator() {
      if (this.quantity == 0) {
        throw "請選擇數量"
      }

      for (const option of this.productSpecSettings) {
        const currentOptionsCount = option.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
        // 如果是必選
        if (option.mustHave && currentOptionsCount === 0) {
          throw `${option.name}尚未選擇`
        }
        // 如果是單選並且是必選
        if (option.mustHave && option.isSingleSelection && currentOptionsCount !== 1) {
          throw `${option.name}尚未選擇`
        }
        // 如果是複選 or 可重複選，加總各項的 quantity 是否符合 minSelect, maxSelect
        if (!option.isSingleSelection) {
          if (currentOptionsCount < option.multiSelectMin) {
            throw `${option.name}尚未選擇`
          }
          if (currentOptionsCount > option.multiSelectionMax) {
            throw `${option.name}選擇數量超過最大值`
          }
        }
      }
    },
    addToCart() {
      try {
        this.cartValidator()
      } catch (error) {
        commonUtilities.createToast("warning", error)
        return
      }

      const orderItem = {
        product: this.product,
        quantity: this.quantity,
        isCombo: false,
        settings: this.productSpecSettings,
        note: this.note
      }
      console.log('加入購物車', orderItem)
      this.$store.dispatch("cart/addToCart", orderItem);
      this.$emit("close");
    }
  },
};
</script>
<style lang="scss" scoped>
.product_detail_container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.product_info {
  width: 100%;
  border-radius: 6px 6px 0 0;
  background-color: #fff;
  // flex-shrink: 0;
  overflow-y: auto;
  flex-grow: 1;
}

.product_img {
  width: 100%;
  padding: 20px 3%;
  flex-shrink: 0;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 24px;
  border-radius: 6px 6px 0 0;
}

.description {
  border-bottom: 1px dotted #000;
  padding-bottom: 15px;
  width: 92%;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.subTitle {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang SC;
  color: #d60c0a;
  margin-left: 10px;
}

.option {
  width: 100%;
  padding: 10px 4%;
  background-color: #eeeeee;
  font-size: 16px;
  font-weight: 400;
  font-family: PingFang SC;
  margin-bottom: 10px;
  border-radius: 6px;

  img {
    width: 32px;
    height: 32px;
  }
}

.option.active {
  border: #FD4F02 2px solid;
  background-color: #fff;
  color: #FD4F02;
}

.customized_options {
  color: #666666;
  font-size: 14px;
  margin-top: 10px;
  width: 100%;
}

.order_note {
  width: 100%;
  padding: 10px 5%;
  height: 120px;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  margin-top: 10px;
  font-size: 18px;
  display: flex;
  flex-direction: column;

  textArea {
    width: 100%;
    flex-grow: 1;
  }

  textArea:focus {
    outline: none;
  }
}
</style>
